// extracted by mini-css-extract-plugin
export default {"smallPrivateTable":"customTable_smallPrivateTable__HzBkG"};